/**
 * Reviewable policy for the merchant-document surfaces owned by Paypercut.js.
 * These values are intentionally separate from merchant appearance options:
 * the hosted action frame owns branded content while this SDK owns only the
 * full-page backdrop and transition between merchant and hosted surfaces.
 */
export const ELEMENTS_ACTION_SHELL_POLICY = {
  /**
   * Allows a slow hosted frame/code-split to connect, while failing well before
   * the payment submission timeout. Hosted Checkout's action coordinator uses
   * the same connection deadline; keep both sides aligned until the protocol is
   * extracted into a shared package.
   */
  bootstrapTimeoutMs: 15_000,
  /** The frame fades first; the longer host fade owns the DOM-removal deadline. */
  frameTransitionMs: 220,
  hostTransitionMs: 400,
  /**
   * The Popover API normally puts the host in the browser top layer. This is the
   * maximum signed 32-bit stacking value used only as a compatibility fallback.
   */
  fallbackZIndex: 2_147_483_647,
  /**
   * A neutral charcoal veil preserves light/dark dialog contrast while leaving
   * enough merchant-page context to communicate that authentication is modal.
   */
  backdropHidden: 'rgb(40 40 40 / 0%)',
  backdropVisible: 'rgb(40 40 40 / 75%)',
  frameBackground: 'transparent',
} as const;
